

// import React, { useState, useEffect, useRef } from 'react';
// import ChatMessage from '../components/ChatMessage';
// import { BASE_URL } from '../config';

// const ChatHistoryPage = () => {
//   const [messages, setMessages] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const messagesEndRef = useRef(null);

//   useEffect(() => {
//     const fetchHistory = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/api/v1/chat/history`, {
//           credentials: 'include'
//         });
//         const history = await response.json();

//           // Filter out consecutive duplicate bot messages
//     const filteredHistory = history.filter((msg, index) => {
//       if (index === 0) return true;
//       const prevMsg = history[index - 1];
//       return !(msg.type === 'bot' && prevMsg.type === 'bot' && msg.text === prevMsg.text);
//     });

//         setMessages(filteredHistory);
//       } catch (err) {
//         console.error('Failed to load chat history:', err);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchHistory();
//   }, []);

//   // Scroll to bottom when messages change
//   useEffect(() => {
//     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [messages]);

//   return (
//     <div className="flex flex-col h-screen bg-gray-50 w-full md:max-w-[450px] md:mx-auto">
//       {/* Header */}
//       <div className="bg-indigo-600 text-white p-4 shadow-md">
//         <div className="flex justify-between items-center">
//           <div>
//             <h1 className="text-xl font-bold">Chat History</h1>
//             <p className="text-sm opacity-80">Your previous conversations</p>
//           </div>
//           {/* <button
//             onClick={() => window.close()}
//             className="px-4 py-2 bg-white bg-opacity-20 rounded-lg hover:bg-opacity-30 transition-colors"
//           >
//             Close
//           </button> */}
//           <button
//   onClick={() => window.close()}
//   className="hover:opacity-60 transition-opacity"
//   aria-label="Close"
// >
//   {/* Pure black cross icon */}
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     className="h-6 w-6 text-black"
//     fill="none"
//     viewBox="0 0 24 24"
//     stroke="currentColor"
//     strokeWidth={2}
//   >
//     <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
//   </svg>
// </button>

//         </div>
//       </div>
      
//       {/* Chat Messages Container */}
//       <div className="flex-1 overflow-y-auto p-4 w-full">
//         {/* <div className="max-w-4xl mx-auto"> */}
//           {isLoading ? (
//             <div className="flex justify-center items-center h-full">
//               <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
//             </div>
//           ) : messages.length === 0 ? (
//             <div className="flex justify-center items-center h-full">
//               <div className="text-center text-gray-500">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-12 w-12 mx-auto mb-4 text-gray-400"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
//                   />
//                 </svg>
//                 <p className="text-lg">No chat history found</p>
//                 <p className="text-sm mt-1">Start a new chat to see messages here</p>
//               </div>
//             </div>
//           ) : (
//             <div className="space-y-4 pb-4 w-full">
//               {messages.map((msg) => {
//                 const messageText = msg.type === 'bot' ? msg.text : msg.userInput;
//                 const imageUrl = msg.imageUrl || null;

//                 return (
//                   <ChatMessage
//                     key={msg._id}
//                     message={messageText}
//                     sender={msg.type}
//                     imageUrl={imageUrl}
//                   />
//                 );
//               })}
//               <div ref={messagesEndRef} />
//             </div>
//           )}
//         </div>
//       {/* </div> */}
//     </div>
//   );
// };

// export default ChatHistoryPage;



import React, { useState, useEffect, useRef } from 'react';
import ChatMessage from '../components/ChatMessage';
import { BASE_URL } from '../config';

const ChatHistoryPage = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const messagesEndRef = useRef(null);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/v1/chat/history`, {
          credentials: 'include',
        });
        const history = await response.json();

        const filteredHistory = history.filter((msg, index) => {
          if (index === 0) return true;
          const prevMsg = history[index - 1];
          return !(msg.type === 'bot' && prevMsg.type === 'bot' && msg.text === prevMsg.text);
        });

        setMessages(filteredHistory);
      } catch (err) {
        console.error('Failed to load chat history:', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistory();
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <div
      style={{
        height: `${viewportHeight}px`,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'white',
        maxWidth: '450px',
        margin: '0 auto',
        position: 'relative',
      }}
    >
      {/* Header */}
      <div
        style={{
          backgroundColor: '#4f46e5',
          color: 'white',
          padding: '1rem',
          position: 'fixed',
          top: 0,
          width: '100%',
          maxWidth: '450px',
          zIndex: 10,
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>Chat History</h1>
            <p style={{ fontSize: '0.875rem', opacity: 0.8 }}>Your previous conversations</p>
          </div>
          <button
            onClick={() => window.close()}
            style={{ opacity: 1, transition: 'opacity 0.2s' }}
            aria-label="Close"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: '24px', width: '24px', color: 'black' }}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Messages area */}
      <div
        style={{
          position: window.innerWidth <= 768 ? 'fixed' : 'absolute',
          top: '64px',
          bottom: '0',
          left: 0,
          right: 0,
          overflowY: 'auto',
          backgroundColor: '#f9fafb',
          // padding: '8px 1rem 0',
             padding: '30px 1rem 1rem',
    boxSizing: 'border-box',   
        }}
      >
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
          </div>
        ) : messages.length === 0 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              flexDirection: 'column',
              textAlign: 'center',
              color: '#6b7280',
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ height: '48px', width: '48px', marginBottom: '1rem', color: '#9ca3af' }}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
            <p style={{ fontSize: '1.125rem' }}>No chat history found</p>
            <p style={{ fontSize: '0.875rem', marginTop: '4px' }}>
              Start a new chat to see messages here
            </p>
          </div>
        ) : (
          <div style={{ paddingBottom: '1rem' }}>
            {messages.map((msg) => {
              const messageText = msg.type === 'bot' ? msg.text : msg.userInput;
              const imageUrl = msg.imageUrl || null;

              return (
                <ChatMessage
                  key={msg._id}
                  message={messageText}
                  sender={msg.type}
                  imageUrl={imageUrl}
                />
              );
            })}
            <div ref={messagesEndRef} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatHistoryPage;
